import { Box, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled(Box) `
  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
`;
export const Divider = styled.div `
  width: 100%;
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
